module.exports = __webpack_public_path__ + "img/kyoto.9cd18651.png";